import { CPD_DONT_SHOW_TIME_SPAN } from './constants';
import { getCPDTimestamp } from './getCPDTimestamp';

export function getDontShowModalTimeElapsed() {
  if (window.localStorage) {
    const now = new Date();
    const msFrom1970 = now.getTime();

    const msWhenCPDBannerWasDeclined = getCPDTimestamp();

    if (msWhenCPDBannerWasDeclined) {
      return msFrom1970 - msWhenCPDBannerWasDeclined > CPD_DONT_SHOW_TIME_SPAN;
    }

    return true;
  }

  return true;
}
